import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "category__product-smallcard bg-light" };
const _hoisted_2 = {
    key: 0,
    class: "product-flags__container product-flags__right"
};
const _hoisted_3 = { class: "product-image" };
const _hoisted_4 = { class: "image__container" };
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "flex-grow-1 d-flex flex-column p-2" };
const _hoisted_7 = { class: "small mb-1" };
const _hoisted_8 = { class: "text-end" };
const _hoisted_9 = { class: "font-weight-bolder text-primary m-0" };
const _hoisted_10 = { class: "small" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (_ctx.product.flags && _ctx.product.flags.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product.flags, (flag) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(['flag', flag.cssClass]),
                        style: _normalizeStyle({ color: flag.foreColor, 'background-color': flag.backgroundColor })
                    }, _toDisplayString(flag.caption), 7));
                }), 256))
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, {
                    to: _ctx.product.url
                }, {
                    default: _withCtx(() => [
                        (_ctx.product.images && _ctx.product.images.length > 0 && _ctx.product.images[0].fullUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.product.images[0].fullUrl,
                                class: "image-item"
                            }, null, 8, _hoisted_5))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 8, ["to"])
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
                to: _ctx.product.url,
                class: "link-unstyled flex-grow-1"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.product.itemNumber), 1),
                    _createElementVNode("h1", null, _toDisplayString(_ctx.product.title), 1)
                ]),
                _: 1
            }, 8, ["to"]),
            (_ctx.product.showPrices)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: _ctx.product.url,
                    class: "align-self-end mt-2 link-unstyled"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.product.priceFormatted), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product?.priceNotes, (note) => {
                                return (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(note.text), 1));
                            }), 256))
                        ])
                    ]),
                    _: 1
                }, 8, ["to"]))
                : _createCommentVNode("", true)
        ])
    ]));
}
